import '../../resources/css/layout/MainLayout.scss';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, Switch, withRouter } from 'react-router-dom';
import { Row } from 'react-bootstrap';
import MainHeader from '../../components/frame/MainHeader';
import MainMenu from '../../components/frame/MainMenu';
// import MainFooter from '../../components/frame/MainFooter';
import VisualPage from '../visual/VisualPage';
import { closeModalLoading, openModalAlert, openModalTip } from '../../actions/index';
import { WAIT_LOGIN, reLoginBySession, doLogout } from '../../actions/login/index';
import { doActivePage } from '../../actions/menu/index';
import ModalAccountConfig from '../../components/login/ModalAccountConfig';
import Loading from '../../components/common/Loading';
import NotFoundPage from './../NotFoundPage';
import { reSiteBySession } from '../../actions/site/index';
import * as Stomp from 'stompjs';

import { dispatchNotifyMsg } from './../../actions/index';
import { dispatchDeviceFwUpgradeACK, dispatchSiteSurveyData, dispatchDeviceUpdatedNotify } from '../../actions/device/index';
import ModalAccountForm from '../../components/login/ModalAccountForm';
import { reGetNotifyBySession } from '../../actions/account';
import ModalConfirm from '../../components/common/ModalConfirm';
import ModalTip from '../../components/common/ModalTip';
import ModalAlert from '../../components/common/ModalAlert';
import ModalLoading from '../../components/common/ModalLoading';
import moment from 'moment';
import FloorPlanProjectPage from '../floorplan/FloorPlanProjectPage';

class MainLayout extends Component {  
  constructor(props) {
    super(props);

    this.state = {
      dashboardLaptopSize: false,
      width: window.innerWidth,
      height: window.innerHeight
    }
  }

  isReloadPage = false;

  isNeedReLogin = ( loginStatus ) => {
    const { doLogout, history } = this.props;

    if (loginStatus === WAIT_LOGIN) {
      const loginParams = window.sessionStorage.getItem(window.CONFIG.PROJECT_ID + window.CONFIG.WEB_CACHE_KEY.LOGIN);

      if (loginParams) {
        return true;
      } else {
        doLogout();
        history.push(window.CONFIG.WEB_ROOT + '/Login');
      }
    }
    return false;
  }

  isNeedReSelectSite = () => {
    const { siteSummaryList, doLogout, history } = this.props;

    if (!siteSummaryList) {
      const siteParams = window.sessionStorage.getItem(window.CONFIG.PROJECT_ID + window.CONFIG.WEB_CACHE_KEY.SITE);

      if (siteParams) {
        return true;
      } else {
        doLogout();
        history.push(window.CONFIG.WEB_ROOT + '/Login');
      }
    }
    return false;
  }

  connectWebSocket = () => {
    const {subscribeTopic} = this.props
    // setting SOCKET
    let socket = new WebSocket(window.CONFIG.SWS_SERVER_WS.url);
    socket.onerror = function(error) {
      console.log('WebSocket Error ', error);
    };
    // location STOMP client
    this.stompClient = Stomp.over(socket);
    // STOMP client connection
    this.stompClient.connect({}, (frame) => {
      console.log("connect success");
      subscribeTopic.forEach((eleTopic) => {
        this.subscribeTopic(eleTopic);
      })
    }, (err) => {
      console.log("connect error");
      window.setTimeout(() => {
        this.connectWebSocket();
      }, 5000)
    });
  }
  
  subscribeTopic = (topic) => {
    // exec subscribe action
    this.stompClient.subscribe(window.CONFIG.SWS_SERVER_WS.subscribePrefix + '/' + topic, (responseBody) => {
        let receiveMessage = JSON.parse(responseBody.body);
        const { selectSite, accountRole, accountInfo, dispatchSiteSurveyData, dispatchDeviceUpdatedNotify } = this.props;
        let isShowNotify = false

        if (topic === 'notifyMsg') {
          if (receiveMessage.site === selectSite) {
            if (accountRole.flagSuperAdmin) {
              isShowNotify = true;
            } else {
              const groups = receiveMessage.group ? receiveMessage.group.split(",") : [];
              groups.forEach(group => {
                if (group.trim() === accountInfo.groupId) {
                  isShowNotify = true;
                }
              });
            }
          }
        } else {
          isShowNotify = true;
        }
        
        if (isShowNotify) {
          if (topic === 'DownlinkExecuteList') {
            if (receiveMessage.status === 'success') {
              const {dispatchNotifyMsg, notifyMsg, dispatchDeviceFwUpgradeACK} = this.props;
              let notrifyResult = [];
              if (notifyMsg) {
                notrifyResult = JSON.parse(JSON.stringify(notifyMsg))
              }
              
              notrifyResult.unshift({
                mac: receiveMessage.mac,
                name: receiveMessage.name,
                command: receiveMessage.command,
                radio: receiveMessage.radio,
                status: "complete",
                time: moment.utc(new Date()).format("yyyy/MM/DD HH:mm:ss")
              })
              dispatchNotifyMsg(notrifyResult);
              if (receiveMessage.command === 'set_fwupgrade') {
                dispatchDeviceFwUpgradeACK(receiveMessage.timestamp);
              }
            }
          }  else if(topic === 'siteSurvey'){
            if(receiveMessage.status === 'success'){
              dispatchSiteSurveyData(JSON.parse(receiveMessage.data).wifi, JSON.parse(receiveMessage.data).wifi1, JSON.parse(receiveMessage.data).wifiAll, JSON.parse(receiveMessage.data).wifi1All, JSON.parse(receiveMessage.data).rogueAll);
            }

          } else if (topic === 'notifyMsg') {
            if (receiveMessage.status === 'success') {
              const {dispatchNotifyMsg, notifyMsg} = this.props;
              let notrifyResult = [];
              if (notifyMsg) {
                notrifyResult = JSON.parse(JSON.stringify(notifyMsg))
              }

              notrifyResult.unshift({
                type: receiveMessage.type,
                mac: receiveMessage.mac,
                name: receiveMessage.name,
                msg: receiveMessage.msg,
                status: "complete",
                time: moment.utc(new Date()).format("yyyy/MM/DD HH:mm:ss")
              })
              dispatchNotifyMsg(notrifyResult);
            }
          } else if (topic === 'firmwareUpgrade') {
            const { closeModalLoading, openModalAlert, openModalTip } = this.props;
            closeModalLoading();
            if (receiveMessage.status === 'success') {
              openModalTip("Your system has been updated to v"+receiveMessage.newVersion+" successfully.", "Update Software", () => {
                const { history, doLogout } = this.props;
                if (history) {
                  doLogout();
                  history.push(window.CONFIG.WEB_ROOT);
                  window.location.reload();
                }
              });
            }
            else {
              openModalAlert("Your system has been updated to v"+receiveMessage.newVersion+" unsuccessfully.", "Update Software");
            }
          } else if (topic === 'deviceStatusUpdate') {
            dispatchDeviceUpdatedNotify(receiveMessage)
          }
        }
    });
  }

  updateDimensions = () => {
    this.setState({ width: window.innerWidth, height: window.innerHeight });

    this.changeDashboardLaptopSizeHandler();
  }

  changeDashboardLaptopSizeHandler = () => {
    const { menuActivePage } = this.props;
    const { width } = this.state;

    if (menuActivePage === "dashboard" && width < 1920) {
      this.setState({
        dashboardLaptopSize: true
      });
    } else {
      this.setState({
        dashboardLaptopSize: false
      });
    }
  }
  
  componentDidMount() {

    const { loginStatus, reLoginBySession, reSiteBySession , match, doActivePage, menuActivePage, reGetNotifyBySession } = this.props;
    window.addEventListener('resize', this.updateDimensions);

    if (this.isNeedReLogin(loginStatus) || this.isNeedReSelectSite()) {
      this.isReloadPage = true;
      reLoginBySession();
      reSiteBySession();
      reGetNotifyBySession();
    }
    
    if (match.params.navName && !menuActivePage) {
      doActivePage(match.params.navName + (match.params.formType ? '/' + match.params.formType : ''));
    }

    this.connectWebSocket();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    const { menuActivePage, history } = this.props;

    if (prevProps.menuActivePage !== menuActivePage) {
      if (menuActivePage && history) {
        if (this.isReloadPage) {
          this.isReloadPage = false;
        } else {
          if(prevProps.menuActivePage === "rf_map/floorplan") {
            // DO NOT remove this condition, the floorplan page need to check the graph status.
          } else {
            history.push(window.CONFIG.WEB_ROOT + '/' + menuActivePage);
          }
        }
        this.changeDashboardLaptopSizeHandler();
      }
    }
  }

  render() {
    const { menuMode, loginStatus } = this.props;
    const { dashboardLaptopSize } = this.state;
    const classMainMenu = 'area-main-menu ' + menuMode;
    const classMainContent = 'main-content ' + menuMode;
    // do auto re-login by session
    if (this.isNeedReLogin(loginStatus)) {
      return (
        <Loading loading={true}></Loading>
      )
    }

    return (
      <div className="main-layout">
        <div className={'main-header' + (dashboardLaptopSize ? ' laptopSize' : '')}>
          <MainHeader />
        </div>
        <div className='main-body'>
          <Row>
            <div className={ classMainMenu }>
              <MainMenu/>
            </div>
            <div className={ classMainContent }>
              <Switch>
                
                <Route path={ window.CONFIG.WEB_ROOT + "/rf_map/floorplan" } exact component={VisualPage} />
                <Route path={ window.CONFIG.WEB_ROOT + "/rf_map/project" } exact component={FloorPlanProjectPage} />
               
                <Route exact path={ window.CONFIG.WEB_ROOT + "/404" } component={NotFoundPage} />
                <Route component={NotFoundPage} />
              </Switch>
            </div>
          </Row>
        </div>
        {/* <div className='main-footer'>
          <MainFooter/>
        </div> */}
        <ModalAccountConfig></ModalAccountConfig>
        <ModalAccountForm></ModalAccountForm>
        <ModalConfirm></ModalConfirm>
			  <ModalTip></ModalTip>
        <ModalAlert></ModalAlert>
        <ModalLoading></ModalLoading>
    </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {  
  return {
    subscribeTopic: ['GuardAbnormal','DownlinkExecuteList','notifyMsg', 'firmwareUpgrade', 'siteSurvey', 'deviceStatusUpdate'],
    loginStatus: state.loginReducers.status,
    authToken: state.loginReducers.authToken,
    accountInfo: state.loginReducers.accountInfo,
    accountRole: state.loginReducers.accountRole,
    selectSite: state.siteReducers.selectSite,
    menuMode: state.menuReducers.displayMode,
    menuActivePage: state.menuReducers.activePage,
    notifyMsg: state.commonReducers.notifyMsg,
    siteSummaryList: state.siteReducers.siteSummaryList,
    timeZoneID: state.loginReducers.timeZoneID,
  }
};

export default withRouter(connect(
  mapStateToProps,
  { doActivePage, reLoginBySession, reSiteBySession, doLogout, dispatchNotifyMsg, closeModalLoading, openModalAlert, openModalTip, reGetNotifyBySession, 
    dispatchDeviceFwUpgradeACK, dispatchSiteSurveyData, dispatchDeviceUpdatedNotify }
)(MainLayout));